import { getLogger } from '../../libs/logger';
import { useCallback } from 'react';
import { useDocumentVisibility, useIsTouchDevice } from '@doxyme/ui/hooks';

const logger = getLogger('usePageVisibilityBeacon');

/**
 * If the user switches browser tab or to a different app,
 * the browser fires the 'visibilitychange' event.
 *
 * On mobile, the browser or OS may shut down our app
 * without firing the 'pagehide' event,
 * which means our final analytics will not be sent.
 *
 * Avoid waiting and async in the beacon as there is not much time.
 *
 * This page has a nice flowchart and explanation:
 * @see https://developer.chrome.com/articles/page-lifecycle-api/
 */
export const usePageVisibilityBeacon = (): void => {
  const isTouchDevice = useIsTouchDevice();

  const beacon = useCallback(() => {
    if (!isTouchDevice) {
      return;
    }

    const { visibilityState } = document;

    /**
     * Log in case visibility change caused a problem.
     */
    logger.info(`visibilitychange ${visibilityState}`);
  }, [isTouchDevice]);

  useDocumentVisibility(beacon);
};
